import { UserDocument } from '@api/document/model/types';
import { DocumentType } from '@utils/enums.ts';
import { downloadDocumentInstanceDocx } from '@api/document-instance';
import { downloadDepositionSummaryDocx } from '@api/deposition-summary';
import { downloadUseCaseDocx } from '@app/services/api/use-case';

/**
 * Download a document from the My Documents table through its export route,
 * which is where the "first draft, check before use" line is added
 * (ZLAYT-1598). Demand letters used to be fetched straight from storage.
 */
export const downloadUserDocument = async (selected: UserDocument) => {
  if (selected.type === DocumentType.DEMAND_LETTER) {
    await downloadDocumentInstanceDocx(selected.id);
    return;
  }
  if (selected.type === DocumentType.USE_CASE) {
    await downloadUseCaseDocx(selected.id);
    return;
  }
  await downloadDepositionSummaryDocx(selected.id);
};
